import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { showErrorMessage, showSuccessMessage } from "../actions";

export const useManagementAction = () => {
  const dispatch = useDispatch();

  /**
   * função assíncrona para executar ações de gestão,
   * realizar ação ao concluir, tratar mensagens de sucesso, erro
   * e limpar o estado do Dialog.
   *
   * @param {Object} body Payload com os dados enviados para a edição de gestão.
   * @param {Function} managementAction Action que executa a ação de edição no backend.
   * @param {string} successMessage Mensagem de sucesso exibida.
   * @param {Function} onComplete Callback executado após a conclusão da ação
   * @param {Function} onFinish Callback de encerramento.
   *
   * @returns {void}
   */
  const handleManagementAction = useCallback(
    async ({
      body,
      managementAction,
      successMessage,
      onComplete,
      onError,
      onFinish,
    }) => {
      try {
        await managementAction(body);
        dispatch(showSuccessMessage(successMessage));
        await onComplete();
      } catch (e) {
        dispatch(
          showErrorMessage(
            e?.response?.data?.message ?? e?.message ?? "app.error.generic",
          ),
        );
        if (onError) onError();
      } finally {
        if (onFinish) onFinish();
      }
    },
    [dispatch]
  );

  return { handleManagementAction };
};
